// @flow
import React from 'react'
import { style } from 'glamor'
import { PhotoSwipe } from 'react-photoswipe'
import { Portal } from 'react-portal'
import { trackSlideshowView } from 'analytics'
import 'style/vendor/photoswipe/photoswipe.css'

import type { ContentfulAsset, PhotoswipeOptions } from 'types'
import type { Location } from 'react-router-dom'

const mapImagestoItems = images =>
  images.map(({ resolutions, file: { url, contentType } }) => {
    if (contentType == null || url == null) return {}
    return /image/.test(contentType)
      ? {
          src: resolutions.src,
          w: resolutions.width,
          h: resolutions.height,
          msrc: resolutions.base64,
        }
      : {
          html: addVideo(url),
        }
  })

const videoWrapper = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  padding: '3%',
})

const video = style({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
})

const addVideo = (src: string) =>
  `
  <div class="${videoWrapper}">
    <video
      class="${video}"
      autoplay
      loop
      webkit-playsinline
      playsinline
      muted
      src="${src}"
    ></video>
  </div>
  `

const defaultOptions = {
  history: false,
  closeOnScroll: false,
  bgOpacity: 0.9,
  shareEl: false,
  zoomEl: false,
  fullscreenEl: false,
}

type Props = {
  images: Array<ContentfulAsset>,
  options: PhotoswipeOptions,
  location: Location,
}

const Slideshow = ({ images, options, location }: Props) => (
  <Portal>
    <PhotoSwipe
      isOpen
      items={mapImagestoItems(images)}
      options={{ ...options, ...defaultOptions }}
      afterChange={ps => {
        const currentImage = images[ps.getCurrentIndex()]

        trackSlideshowView(location, currentImage.title)
      }}
    />
  </Portal>
)

export default Slideshow



// WEBPACK FOOTER //
// ./src/components/Slideshow.js